<template>
  <v-autocomplete
    v-model="chosenUserRole"
    v-bind="$attrs"
    :items="formattedUserRoles"
    append-icon="mdi-magnify"
    :loading="isLoading"
    :disabled="isLoading"
  />
</template>

<script>
export default {
  name: 'UserRolePicker',
  props: {
    initial: {
      type: String,
      default: function() {
        return 'open';
      },
    },
  },
  data: () => ({
    chosenUserRole: '',
    isLoading: false,
    formattedUserRoles: [{ text: 'End User', value: 'user' }],
  }),
  watch: {
    initial(newValue, oldValue) {
      console.log('changing inital value of picker');
      this.chosenUserRole = this.initial;
    },
    chosenUserRole(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('update:chosen-user-role', this.chosenUserRole ? this.chosenUserRole : '');
      }
    },
  },
  async mounted() {
    this.initial ? (this.chosenUserRole = this.initial) : (this.chosenUserRole = '');
  },
  methods: {},
};
</script>

<style lang="sass"></style>
